import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map } from 'lodash';
import { Cushion, LinearGradient, Rectangle, Space, Typography } from '@pitchero/react-ui';
import Icon from '../icon';
import { Trans } from '../../lib/i18n';
import WebsiteListItem from './website-list-item';

const AdminList = ({ clubs, leagueWebsites, competitions, onClickBack }) => {
  const hasClubs = !isEmpty(clubs);
  const hasLeagues = !isEmpty(leagueWebsites);
  const hasCompetitions = !isEmpty(competitions);

  if (!hasClubs && !hasLeagues && !hasCompetitions) {
    return null;
  }

  const showSubHeaders =
    (hasClubs && hasLeagues && hasCompetitions) ||
    (hasClubs && hasLeagues) ||
    (hasClubs && hasCompetitions) ||
    (hasLeagues && hasCompetitions);

  const renderAdminSection = (type, sites) => (
    <>
      {showSubHeaders && (
        <Cushion bottom="medium">
          <Typography preset="tag--large" color="black" component="div">
            <Trans i18nKey={`common:network_panel_admin_list_${type}_header`}>{type}</Trans>
          </Typography>
        </Cushion>
      )}
      {map(sites, (site) => (
        <Space vertical="xsmall" key={site.id}>
          <a
            aria-label={site.name}
            href={`/token-redirect?url=${encodeURIComponent(site.adminUrl)}`}
            title={site.name}
          >
            <WebsiteListItem website={site} />
          </a>
        </Space>
      ))}
    </>
  );

  return (
    <>
      <LinearGradient
        component="div"
        angle={90}
        stops={[
          [0, 'mercury'],
          [100, 'white'],
        ]}
        style={{ flexShrink: 0 }}
      >
        <Cushion vertical="large" horizontal="xlarge">
          <div
            onClick={onClickBack}
            role="button"
            tabIndex={-1}
            onKeyDown={onClickBack}
            style={{ cursor: 'pointer' }}
          >
            <Space right="small">
              <Icon name="back-arrow" size={18} topOffset={4} color="black" />
            </Space>
            <Typography preset="subtitle--small" color="black">
              <Trans i18nKey="common:network_panel_admin_link">Admin dashboard</Trans>
            </Typography>
          </div>
        </Cushion>
      </LinearGradient>
      <Rectangle fill="white" style={{ flex: 1, overflowY: 'auto' }}>
        <Cushion vertical="large" horizontal="xlarge">
          {hasClubs && renderAdminSection('clubs', clubs)}
          {hasCompetitions && renderAdminSection('competitions', competitions)}
          {hasLeagues && renderAdminSection('leagues', leagueWebsites)}
        </Cushion>
      </Rectangle>
    </>
  );
};

AdminList.propTypes = {
  clubs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      adminUrl: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  competitions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      adminUrl: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  leagueWebsites: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      adminUrl: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  onClickBack: PropTypes.func.isRequired,
};

export default AdminList;
